var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","absolute":"false","color":_vm.appColor,"dark":"","height":"200px","src":require("../../../assets/backgrounds/kings_campus.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }